const UI_STATUS = {
  LOADING: {id: 0},
  READY: {id: 1},
  ERROR: {id: -1},
}

export default UI_STATUS
